module.exports = __webpack_public_path__ + "9d91bd087bd1cc0bded665332c59eb9a.MP3";